import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C } from "@/helpers/global";

export const SettingService = {
    Init(callback) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.SETTING + "/init").then((data) => {
            callback(true, data);
        }).catch((err) => {
            if (!err) { err = {}; }
            callback(false, C.Str(C.Str(err.statusText, err.message), "There was a problem with the server! Please try again"));
        });
    },
    InitAsync() {
        return new Promise((resolve, reject) => {
            Ajax.Api(MethodType.Get, Enums.SERVICE.SETTING + "/init").then((data) => {
                resolve(data);
            }).catch((err) => {
                reject(C.Str(C.Str(err.statusText, err.message), "There was a problem with the server! Please try again"));
            });
        });
    },
    ListType(type, callback) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.SETTING + '/' + type).then((data) => {
            callback(data);
        });
    },
    ListKeys(keys, callback) {
        const j = { keys: keys.toString() };
        Ajax.Api(MethodType.Post, Enums.SERVICE.SETTING + '/keys', j).then((data) => {
            callback(data);
        });
    },
    Save(j, callback, wait) {
        Ajax.Api(MethodType.Put, Enums.SERVICE.SETTING, j, wait).then((data) => {
            callback(data);
        });
    },
    Send(j, callback, wait) {
        Ajax.Api(MethodType.Post, Enums.SERVICE.SETTING + '/send', j, wait).then((data) => {
            callback(data);
        });
    },
    Import(j, callback, wait) {
        Ajax.Api(MethodType.Post, Enums.SERVICE.SETTING + '/import', j, wait).then((data) => {
            callback(data);
        });
    },
    Export(j, callback, wait) {
        Ajax.Api(MethodType.Post, Enums.SERVICE.SETTING + '/export', j, wait).then((data) => {
            callback(JSON.parse(data));
        });
    },
    Dashboard(j, callback, wait) {
        Ajax.Api(MethodType.Post, Enums.SERVICE.SETTING + '/dashboard', j, wait).then((data) => {
            callback(JSON.parse(data));
        });
    }
};